import { render, staticRenderFns } from "./ListColumnsSetter.vue?vue&type=template&id=7bb51979&"
import script from "./ListColumnsSetter.vue?vue&type=script&lang=js&"
export * from "./ListColumnsSetter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports